export class AbortControllerFactory {
  create(): AbortController {
    return new AbortController();
  }
}
